import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, Drawer, FormControl, FormLabel, Grid, Input, ModalClose } from "@mui/joy";
import React from "react";
import { Building } from "../Pages/BuildingList";

interface BuildingDialogProps {
	open: boolean;
	close: Function;
	bld?: Building;
}

export default function BuildingDialog(props: BuildingDialogProps) {
	const [open, setOpen] = React.useState(false);
	const [geocoding, setGeocoding] = React.useState(false);
	const [geocodeMessage, setGeocodeMessage] = React.useState("");
	const [building, setBuilding] = React.useState({
		Name: "",
		ID: "",
		Address1: "",
		Address2: "",
		City: "",
		State: "",
		Zip: "",
		Active: true,
	} as Building
		
	);

	React.useEffect(() => {
		setOpen(props.open);
		setGeocodeMessage("");
		setBuilding(props.bld ?? ({
			Name: "",
			ID: "",
			Address1: "",
			Address2: "",
			City: "",
			State: "",
			Zip: "",
			Active: true,
		} as Building));
	}, [props.open, props.bld]);

	const close = (bid: string) => {
		props.close(bid);
	};

	const sizes = {
		xs: 12,
		sm: 6,
		md: 4,
		lg: 3,
	};

	const save = () => {
		fetch("Building/SaveBuildingData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({
				buildings_id: building.ID ?? "",
				building_name: building.Name,
				address1: building.Address1,
				address2: building.Address2,
				city: building.City,
				state: building.State,
				zip: building.Zip,
				is_active: building.Active,
				latitude: building.Latitude,
				longitude: building.Longitude,
			}),
		})
			.then((x) => x.text())
			.then((x) => {
				console.log(x);
				close(x);
			});
	};

	const geocode = () => {
		if (!building.ID) return;

		setGeocoding(true);
		setGeocodeMessage("");
		fetch("Building/GeocodeBuilding", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ buildingsId: building.ID }),
		})
			.then((x) => x.json())
			.then((x) => {
				setGeocodeMessage(x.message ?? "");
				if (x.success) {
					setBuilding({ ...building, Latitude: x.latitude, Longitude: x.longitude });
				}
			})
			.finally(() => setGeocoding(false));
	};

	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={() => close("")} />
				<DialogTitle>{building.ID ? "Edit Building" : "Add Building"}</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Building Information</FormLabel>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Name</FormLabel>
								<Input
									value={building.Name}
									onChange={(event) => {
										setBuilding({ ...building, Name: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Active?</FormLabel>
								<Checkbox checked={building.Active} onChange={(event) => setBuilding({ ...building, Active: event.target.checked })} />
							</FormControl>
						</Grid>

						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Address Information</FormLabel>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Street Address 1</FormLabel>
								<Input
									value={building.Address1}
									onChange={(event) => {
										setBuilding({ ...building, Address1: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Street Address 2</FormLabel>
								<Input
									value={building.Address2}
									onChange={(event) => {
										setBuilding({ ...building, Address2: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>City</FormLabel>
								<Input
									value={building.City}
									onChange={(event) => {
										setBuilding({ ...building, City: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>State</FormLabel>
								<Input
									value={building.State}
									onChange={(event) => {
										setBuilding({ ...building, State: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Zip</FormLabel>
								<Input
									value={building.Zip}
									onChange={(event) => {
										setBuilding({ ...building, Zip: event.target.value });
									}}></Input>
							</FormControl>
						</Grid>

						<Grid xs={12}>
							<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Coordinates</FormLabel>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Latitude</FormLabel>
								<Input value={building.Latitude ?? ""} readOnly />
							</FormControl>
						</Grid>
						<Grid {...sizes}>
							<FormControl>
								<FormLabel>Longitude</FormLabel>
								<Input value={building.Longitude ?? ""} readOnly />
							</FormControl>
						</Grid>
						<Grid xs={12}>
							<Button disabled={!building.ID || geocoding} loading={geocoding} onClick={geocode}>
								Retrieve Coordinates
							</Button>
							{geocodeMessage && <FormLabel sx={{ display: "block", mt: 1 }}>{geocodeMessage}</FormLabel>}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={() => close("")} sx={{ mx: 1 }}>
							Close
						</Button>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
